import { relayPostMessageToRcIframe } from "../modules/realityCheckIframe";

const isInIframe = ((): boolean => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
})();

/**
 * @internal
 * Posts a postMessage to parent and possibly rc iframe
 * @param message
 */
export const postToOperator = (message: unknown): void =>
{
    relayPostMessageToRcIframe(message);

    if (isInIframe) {
        window.parent.postMessage(message, "*");
    }
};
